import { MagnifyMinusCursorIcon } from './MagnifyMinusCursorIcon';

/**
 * author: Michael Richins
 * id 616EA8BF-F84A-41BC-A933-5A4AF1E4E793
 * name magnify-minus-cursor
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magnify-minus-cursor.svg
 * tags
 */
export const ZoomOutCursorIcon = MagnifyMinusCursorIcon;
export default ZoomOutCursorIcon